module.exports = __webpack_public_path__ + "static/media/logo-moraujo.001753de.png";